<template>
  <div class="vehicle-trade-list">
    <div class="header">
      <h2>申请列表</h2>
    </div>
    
    <div class="filter-section">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择状态" clearable>
            <el-option label="待处理" value="pending"></el-option>
            <el-option label="处理中" value="processing"></el-option>
            <el-option label="已完成" value="done"></el-option>
            <el-option label="失败" value="failed"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadList">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="table-section">
      <el-table
        :data="tableData"
        border
        stripe
        v-loading="loading"
        style="width: 100%">
        <el-table-column prop="id" label="任务ID" min-width="100"></el-table-column>
        <el-table-column prop="buyerName" label="买方名称" min-width="120"></el-table-column>
        <el-table-column prop="sellerName" label="卖方名称" min-width="120"></el-table-column>
        <el-table-column prop="carPlate" label="车牌号" min-width="120"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 'pending'" type="warning">待处理</el-tag>
            <el-tag v-else-if="scope.row.status === 'processing'" type="info">处理中</el-tag>
            <el-tag v-else-if="scope.row.status === 'done'" type="success">已完成</el-tag>
            <el-tag v-else-if="scope.row.status === 'failed'" type="danger">失败</el-tag>
            <el-tag v-else>{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="retryCount" label="重试次数" min-width="100"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="viewDetail(scope.row.id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleTradeList',
  data() {
    return {
      loading: false,
      tableData: [],
      filterForm: {
        status: null
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = true
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      if (this.filterForm.status !== null && this.filterForm.status !== '') {
        params.status = this.filterForm.status
      }
      
      this.$http.get('/VehicleTrade/list', { params })
        .then(res => {
          this.loading = false
          if (res.data.success) {
            this.tableData = res.data.data.list
            this.pagination.total = res.data.data.total
          } else {
            this.$message.error(res.data.message || '查询失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请重试')
        })
    },
    resetFilter() {
      this.filterForm.status = null
      this.pagination.page = 1
      this.loadList()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.page = 1
      this.loadList()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadList()
    },
    viewDetail(id) {
      this.$router.push(`/vehicle-trade/detail/${id}`)
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.vehicle-trade-list {
  padding: 20px;
}

.header {
  margin-bottom: 20px;
}

.header h2 {
  font-size: 24px;
  color: #333;
}

.filter-section {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination-section {
  margin-top: 20px;
  text-align: right;
}
</style>

